module.exports = __webpack_public_path__ + "static/media/tabs-icon-draw-objects.95a0be8e.svg";